import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert } from "../Alerts/actions";
import { fetchHandoverSuccess, fetchHandoverFailure } from "./actions";
import { FETCH_HANDOVER } from "./constants";

export function* fetchHandoverSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { locationId } = payload || {};
  const query = locationId ? `?location_id=${locationId}` : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/observation/handover${query}`,
    );
    // apiResponse wraps the body as { status, data: [...], message }.
    const rows = data?.data ?? [];
    yield put(
      fetchHandoverSuccess({
        residents: Array.isArray(rows) ? rows : [],
        fetchedAt: new Date().toISOString(),
      }),
    );
  } catch (e) {
    yield put(fetchHandoverFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Error while loading the handover digest."));
  }
}

export function* fetchHandoverFlow() {
  yield takeEvery(FETCH_HANDOVER, fetchHandoverSaga);
}

export default function* HandoverSaga() {
  yield all([fetchHandoverFlow()]);
}
